import React, { Fragment } from 'react';
import { Edit2 } from '@finect/tabular-icons/edit-2';
import { getViewType } from '../FieldForm/utils';
import { EditAction, Inner } from './partials';
import { FORMATTERS } from './utils';
export var FieldLabel = function FieldLabel(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onEditAction = _ref.onEditAction,
    nullValue = _ref.nullValue;
  var viewType = getViewType(field);
  var formatter = FORMATTERS[viewType];
  var formattedValue = formatter ? formatter(field, value) : value;
  var handleAction = function handleAction() {
    onEditAction && onEditAction(field);
  };
  var label = React.createElement(Fragment, null, formattedValue !== null ? formattedValue : nullValue);
  if (!onEditAction) {
    return React.createElement("span", null, label);
  }
  return React.createElement(Inner, null, label, onEditAction ? React.createElement(EditAction, {
    role: "button",
    onClick: handleAction
  }, React.createElement(Edit2, {
    size: "16px"
  })) : null);
};